import { render } from "./amazonec2.vue?vue&type=template&id=46ce2eb5"
import script from "./amazonec2.vue?vue&type=script&lang=js"
export * from "./amazonec2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__